import React from "react"
import CarrotPlanRequiredPage from "../components/carrot-plan-required-redirect"

export default function CarrotPlanRequiredRedirect() {
  return <CarrotPlanRequiredPage />
}
